import * as api from "./api/index";
import * as endpoints from "./api/endpoints";

const state = () => ({
  quantity_warnings: [],
  quantity_warning_transaction_types: [],
});

const mutation_types = {
  SET_QUANTITY_WARNINGS: "SET_QUANTITY_WARNINGS",
  SET_QUANTITY_WARNING_TRANSACTION_TYPES: "SET_QUANTITY_WARNING_TRANSACTION_TYPES",
};

const mutations = {
  [mutation_types.SET_QUANTITY_WARNINGS]: (state, payload) => {
    state.quantity_warnings = payload;
  },
  [mutation_types.SET_QUANTITY_WARNING_TRANSACTION_TYPES]: (state, payload) => {
    state.quantity_warning_transaction_types = payload;
  },
};

const actions = {
  getQuantityWarnings({ commit }, payload) {
    return api.fetchFull(
      endpoints.QUANTITY_WARNINGS,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  getQuantityWarningByUuid({ commit }, payload) {
    return api.fetchFull(
      endpoints.QUANTITY_WARNINGS + "/" + payload.uuid,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  createQuantityWarning({ commit }, payload) {
    return api.post(
      endpoints.QUANTITY_WARNINGS,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  updateQuantityWarning({ commit }, payload) {
    return api.put(
      endpoints.QUANTITY_WARNINGS + "/" + payload.uuid,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  deleteQuantityWarning({ commit }, payload) {
    return api.remove(
      endpoints.QUANTITY_WARNINGS_PRODUCTS + "/" + payload.uuid,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  getQuantityWarningDocuments({ commit }, payload) {
    return api.fetchFull(
      endpoints.QUANTITY_WARNINGS_PRODUCTS + "/" + payload.uuid + "/documents",
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },

  getQuantityWarningTransactionTypes({ commit }, payload) {
    return api.fetchFull(
      endpoints.SM_TRANSACTION_TYPES,
      payload,
      commit,
      (response) => {
        commit(
          mutation_types.SET_QUANTITY_WARNING_TRANSACTION_TYPES,
          Array.isArray(response?.data?.data) ? response.data.data : Array.isArray(response?.data) ? response.data : []
        );
        return response;
      }
    );
  },

  getQuantityWarningFulfilled({ commit }, payload) {
    return api.fetchFull(
      endpoints.QUANTITY_WARNINGS_FULFILLED,
      payload,
      commit,
      (response) => {
        return response;
      }
    );
  },
};

const getters = {
  quantityWarnings: (state) => state.quantity_warnings,
  quantityWarningTransactionTypes: (state) => state.quantity_warning_transaction_types,
};

export { state, mutations, actions, getters };
